export default __webpack_public_path__ + "static/media/H4002.e1156b95.mp3";